module.exports = __webpack_public_path__ + "static/media/room-worldclub.948028d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/room-worldclub.jpg
// module id = 680
// module chunks = 6